module.exports = __webpack_public_path__ + "img/user_pic.17f2c2b1.png";